import React, { useRef } from "react";

import styles from "./FileUploadArea.module.scss";
import { ReactComponent as Upload } from "assets/icons/upload.svg";
import { ReactComponent as Delete } from "assets/icons/delete.svg";

interface FileUploadAreaProps {
  files: File[];
  setFiles: (files: File[]) => void;
}

const FileUploadArea = ({ files, setFiles }: FileUploadAreaProps) => {
  const inputFileRef = useRef<HTMLInputElement>(null);

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    if (droppedFiles.length <= 0) {
      return;
    }
    setFiles([...files, ...droppedFiles]);
  };

  const handleNewFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files;
    if (newFiles === null) {
      return;
    }
    setFiles([...files, ...Array.from(newFiles)]);
  };

  const handleRemoveFile = (fileIndex: number) => {
    setFiles([...files.slice(0, fileIndex), ...files.slice(fileIndex + 1)]);
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.uploadBox}
        onClick={() => inputFileRef.current?.click()}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
      >
        <input
          multiple
          hidden
          ref={inputFileRef}
          type="file"
          onChange={handleNewFiles}
        />
        {files.length <= 0 ? (
          <>
            <Upload />
            <span>Drag your file here or click here to upload</span>
          </>
        ) : (
          <div className={styles.filesBox}>
            {files.map((file, i) => {
              return (
                <div key={file.name} className={styles.row}>
                  <span>{file.name}</span>
                  <Delete onClick={() => handleRemoveFile(i)} />
                </div>
              );
            })}
          </div>
        )}
      </div>
      {files.length > 0 && (
        <div className={styles.footer}>
          <div>{files.length} files</div>
          <div className={styles.clear} onClick={() => setFiles([])}>
            Clear
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadArea;
